<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <div class="row" *ngIf="currentUser">
      <section class="col-md-5 col-12" id="page-accordion">
        <!--REQUEST DETAIL SECTION-->
        <div class="card" *ngIf="currentUser" [ngClass]="activeTab === 'request' ? 'active' : ''">
          <div class="card-title px-2 mb-0" (click)="changeTab('request')">
            <h4>{{ "MENU.DETAIL_REQUEST" | translate }}</h4>
          </div>
          <div [ngClass]="activeTab === 'request' ? 'card-body' : 'd-none'">
            <div class="row">
              <div class="col-md-6 col-12">
                <label class="font-small-4 font-weight-bold">{{ "CUSTOMER" | translate }}:</label>
                <p class="font-medium-1">{{ request.client }}</p>
              </div>
              <div class="col-md-6 col-12">
                <label class="font-small-4 font-weight-bold">{{ "CUSTOMER_REFERENCE" | translate }}:</label>
                <p class="font-medium-1" *ngIf="request.referent?.firstname && request.referent?.lastname">{{ request.referent?.firstname }} {{ request.referent?.lastname }}</p>
                <p class="font-medium-1" *ngIf="!request.referent?.firstname && !request.referent?.lastname">{{ "FIELD_NOT_SPECIFIED" | translate }}</p>
              </div>
              <div class="col-md-6 col-12">
                <label class="font-small-4 font-weight-bold">{{ "FIGURE" | translate }}:</label>
                <p class="font-medium-1">{{ request.figure }}</p>
              </div>
              <div class="col-md-6 col-12 d-flex align-items-center">
                <a class="btn btn-outline-primary" target="_blank" [routerLink]="'/dashboard/detail-request/' + idRequest" [queryParams]="{ destination: 'proposed' }">{{ "MENU.DETAIL_REQUEST" | translate }}</a>
              </div>
            </div>
          </div>
        </div>
        <!--/REQUEST DETAIL SECTION-->

        <!--CURRENT_CONTRACT_SECTION-->
        <div class="card" *ngIf="currentUser" [ngClass]="activeTab === 'contract' ? 'active' : ''">
          <div class="card-title px-2 mb-0" (click)="changeTab('contract')">
            <h4>{{ "CURRENT_CONTRACT" | translate }}</h4>
          </div>
          <div [ngClass]="activeTab === 'contract' ? 'card-body' : 'd-none'">
            <div class="row">
              <div class="col-md-6 col-12">
                <label class="font-small-4 font-weight-bold">{{ "CONTRACT_TYPE" | translate }}:</label>
                <p class="font-medium-1">{{ currentUser.contract.current_contract_type_name ? currentUser.contract.current_contract_type_name : ("FIELD_NOT_SPECIFIED" | translate) }}</p>
              </div>
              <div class="col-md-6 col-12">
                <label class="font-small-4 font-weight-bold">{{ "SALARY_YEARLY_GROSS" | translate }}:</label>
                <p class="font-medium-1">{{ _utilService.addDotsToNumber(currentUser.contract.current_ral) }} &euro;</p>
              </div>
              <div class="col-md-6 col-12">
                <label class="font-small-4 font-weight-bold">{{ "NET_MONTHLY_12" | translate }}:</label>
                <p class="font-medium-1">{{ _utilService.addDotsToNumber(currentUser.contract.current_net_monthly) }} &euro;</p>
              </div>
              <div class="col-md-6 col-12">
                <label class="font-small-4 font-weight-bold">{{ "NOTICE" | translate }}:</label>
                <p class="font-medium-1">
                  {{ currentUser.contract.current_notice_resignation ? currentUser.contract.current_notice_resignation : ("FIELD_NOT_SPECIFIED" | translate) }}
                  {{ currentUser.contract.current_notice_resignation ? ("DAYS" | translate) : null }}
                </p>
              </div>
              <div class="col-md-6 col-12">
                <label class="font-small-4 font-weight-bold">{{ "MONTHLY_BONUSES" | translate }}:</label>
                <p class="font-medium-1">{{ currentUser.contract.current_bonus }} &euro;</p>
              </div>
              <div class="col-md-6 col-12">
                <label class="font-small-4 font-weight-bold">{{ "TICKET_TOTAL_MONTH" | translate }}:</label>
                <p class="font-medium-1">{{ currentUser.contract.current_ticket_monthly_value }} &euro;</p>
              </div>
              <div class="col-md-6 col-12">
                <label class="font-small-4 font-weight-bold">{{ "JOB_SITE" | translate }}:</label>
                <p class="font-medium-1">{{ currentUser.contract.current_site_name ? currentUser.contract.current_site_name : ("FIELD_NOT_SPECIFIED" | translate) }}</p>
              </div>
            </div>
          </div>
        </div>
        <!--/CURRENT_CONTRACT_SECTION-->
      </section>

      <section class="col-md-7 col-12" id="page-accordion2" *ngIf="currentUser">
        <!--DESIRED_CONTRACT_SECTION-->
        <div class="card" *ngIf="currentUser" [ngClass]="activeTab === 'desired' ? 'active' : ''">
          <div class="card-title px-2 mb-0" (click)="changeTab('desired')">
            <h4>{{ "DESIRED_CONTRACT" | translate }}</h4>
          </div>
          <div [ngClass]="activeTab === 'desired' ? 'card-body' : 'd-none'">
            <div class="row">
              <div class="col-md-6 col-12">
                <label class="font-small-4 font-weight-bold">{{ "CONTRACT_TYPE" | translate }}:</label>
                <p class="font-medium-1">{{ currentUser?.contract?.desired_contract_type_name }}</p>
              </div>
              <div class="col-md-6 col-12">
                <label class="font-small-4 font-weight-bold">{{ "LEVEL" | translate }}:</label>
                <p class="font-medium-1">{{ currentUser.contract.desired_level || ("FIELD_NOT_SPECIFIED" | translate) }}</p>
              </div>
              <div class="col-md-6 col-12">
                <label class="font-small-4 font-weight-bold">{{ "SALARY_YEARLY_GROSS" | translate }}:</label>
                <p class="font-medium-1">{{ _utilService.addDotsToNumber(currentUser?.contract?.desired_salary_gross_yearly) }} &euro;</p>
              </div>
              <div class="col-md-6 col-12">
                <label class="font-small-4 font-weight-bold">{{ "MONTHLY_BONUSES" | translate }}:</label>
                <p class="font-medium-1">{{ currentUser.contract.desired_bonus }} &euro;</p>
              </div>
              <div class="col-md-6 col-12">
                <label class="font-small-4 font-weight-bold">{{ "TICKET_TOTAL_MONTH" | translate }}:</label>
                <p class="font-medium-1" *ngIf="currentUser && currentUser.contract.desired_ticket_monthly_value">{{ _utilService.addDotsToNumber(currentUser.contract.desired_ticket_monthly_value) }} &euro;</p>
                <p class="font-medium-1" *ngIf="currentUser && !currentUser.contract.desired_ticket_monthly_value">0 &euro;</p>
              </div>
              <div class="col-md-6 col-12">
                <label class="font-small-4 font-weight-bold">{{ "SALARY_MONTH_12" | translate }}:</label>
                <p class="font-medium-1">{{ _utilService.addDotsToNumber(currentUser?.contract?.desired_net_monthly_12) }} &euro;</p>
              </div>
              <div class="col-md-6 col-12">
                <label class="font-small-4 font-weight-bold">{{ "SALARY_MONTH_13" | translate }}:</label>
                <p class="font-medium-1">{{ _utilService.addDotsToNumber(currentUser?.contract?.desired_net_monthly_13) }} &euro;</p>
              </div>
              <div class="col-md-6 col-12">
                <label class="font-small-4 font-weight-bold">{{ "TOTAL_SALARY_MONTH_13" | translate }}:</label>
                <p class="font-medium-1">{{ _utilService.addDotsToNumber(currentUser?.contract?.desired_total_net_monthly_13) }} &euro;</p>
              </div>
              <div class="col-md-6 col-12">
                <label class="font-small-4 font-weight-bold">{{ "CITY" | translate }}:</label>
                <p class="font-medium-1">{{ currentUser.contract.desired_city_name }}</p>
              </div>
              <div class="col-md-6 col-12">
                <label class="font-small-4 font-weight-bold">{{ "JOB_SITE" | translate }}:</label>
                <p class="font-medium-1">{{ currentUser.contract.desired_site_name }}</p>
              </div>
              <div class="col-md-6 col-12" *ngIf="currentUser.contract.desired_contract_type_name === 'Partita IVA'">
                <label class="font-small-4 font-weight-bold">{{ "COST_DAILY" | translate }}:</label>
                <p class="font-medium-1">{{ currentUser.contract.desired_total_daily }}</p>
              </div>
            </div>
          </div>
        </div>
        <!--/DESIRED_CONTRACT_SECTION-->

        <!--DETAIL_CANDIDATE_SECTION-->
        <div class="card" *ngIf="currentUser" [ngClass]="activeTab === 'candidate' ? 'active' : ''">
          <div class="card-title px-2 mb-0" (click)="changeTab('candidate')">
            <h4>{{ "TITLES.USERS_TYPES_SINGULAR.candidate" | translate }}</h4>
          </div>
          <div [ngClass]="activeTab === 'candidate' ? 'card-body' : 'd-none'">
            <div class="row">
              <div class="col-md-4 col-12">
                <label class="font-small-4 font-weight-bold">{{ "FIRSTNAME" | translate }}:</label>
                <a class="font-medium-1 text-primary cursor-pointer d-block" target="_blank" [routerLink]="'/dashboard/candidate/edit/' + currentUser.hash">{{ currentUser.firstname }} {{ currentUser.lastname }}</a>
              </div>
              <div class="col-md-4 col-12">
                <label class="font-small-4 font-weight-bold">{{ "FIGURE" | translate }}:</label>
                <p class="font-medium-1">{{ currentUser.figure_name }}</p>
              </div>
              <div class="col-md-4 col-12">
                <label class="font-small-4 font-weight-bold">{{ "APPRENTICEABLE" | translate }}:</label>
                <p class="font-medium-1 text-{{ currentUser.apprenticeship >= 30 ? 'danger' : 'success' }}">{{ currentUser.apprenticeship >= 30 ? ("NO" | translate) : ("YES" | translate) }}</p>
              </div>
            </div>
          </div>
        </div>
        <!--/DETAIL_CANDIDATE_SECTION-->
      </section>
    </div>
    <div class="row">
      <section class="col-12">
        <!-- PROPOSE_CONTRACT_SECTION-->
        <div class="card" *ngIf="currentUser">
          <div class="card-body">
            <div class="card-title">
              <h4>{{ "PROPOSAL" | translate }}</h4>
            </div>
            <!-- TYPE CONTRACT INFOMRATION-->
            <div class="row">
              <div [class]="'form-group col-12 col-md-' + (_contractManager.typeIsApprendistato || _contractManager.typeIsStage ? 4 : 6)">
                <label for="contract_id">{{ "CONTRACT_TYPE" | translate }}<sup class="text-danger">*</sup></label>
                <ng-select id="contract_id" [items]="_contractService.list" bindLabel="name" bindValue="id" [closeOnSelect]="true" [clearable]="false" [(ngModel)]="_contractManager.data.contract"
                  (change)="_contractManager.changeContract($event)"></ng-select>
              </div>
              <div class="form-group col-12 col-md-4" *ngIf="_contractManager.typeIsApprendistato">
                <label for="contract_level">{{ "DURATION" | translate }}<sup class="text-danger">*</sup></label>
                <input type="number" min="1" max="36" [defaultValue]="3" class="form-control {{ !_contractManager.contractDuration ? 'is-invalid' : '' }}"
                  [(ngModel)]="_contractManager.contractDuration" [ngModelOptions]="{ standalone: true }" (change)="_contractManager.updateData()" />
              </div>
              <div [class]="'form-group col-12 col-md-' + (_contractManager.typeIsApprendistato ? 4 : 6)" *ngIf="!_contractManager.typeIsStage">
                <label for="contract_level">{{ "LEVEL" | translate }}<sup class="text-danger">*</sup></label>
                <ng-select *ngIf="_contractManager.levels_for_select.length > 0" id="contract_level" class="{{ !_contractManager.data.level ? 'is-invalid' : '' }}"
                  [(ngModel)]="_contractManager.data.level" [closeOnSelect]="true" [clearable]="false" [openOnEnter]="false" [virtualScroll]="true"
                  (change)="_contractManager.changeLevel(true, false)">
                  <ng-option *ngFor="let lvl of _contractManager.levels_for_select" [value]="lvl">{{ lvl }}</ng-option>
                </ng-select>
                <select *ngIf="_contractManager.levels_for_select.length < 1" disabled class="form-control"></select>
              </div>
              <div class="form-group col-12 col-md-4" *ngIf="_contractManager.typeIsApprendistato || _contractManager.typeIsStage">
                <label for="contract_level">{{ "TUTOR" | translate }}<sup class="text-danger">*</sup></label>
                <ng-select [closeOnSelect]="true" [clearable]="false" [(ngModel)]="_contractManager.data.tutor_hash">
                  <ng-option *ngFor="let tutor of _contractManager.tutors" class="form-control {{ !_contractManager.data.tutor_hash ? 'is-invalid' : '' }}" [value]="tutor.hash">{{ tutor.firstname }} {{ tutor.lastname }}</ng-option>
                </ng-select>
              </div>
              <div class="form-group col-md-4 col-12" *ngIf="!_contractManager.typeIsStage">
                <label for="contract_trial">{{ "CONTRACT_TRIAL_DAYS" | translate }}<sup class="text-danger">*</sup></label>
                <input readonly type="number" id="contract_trial" class="form-control" [(ngModel)]="_contractManager.data.trial" />
              </div>
              <div class="form-group col-md-4 col-12">
                <label for="contract_role">{{ "DUTY" | translate }}<sup class="text-danger">*</sup></label>
                <ng-select bindValue="id" bindLabel="name" id="contract_role" class="{{ !_contractManager.data.role ? 'is-invalid' : '' }}"
                  [(ngModel)]="_contractManager.data.role" [closeOnSelect]="true" [clearable]="false" [openOnEnter]="false" [virtualScroll]="true" [items]="_userFigureService.list"></ng-select>
              </div>
              <div class="form-group col-md-4 col-12">
                <label for="contract_program">{{ "CONTRACT_PROGRAM" | translate }}<sup class="text-danger">*</sup></label>
                <ng-select id="contract_program" bindLabel="label" bindValue="value" class="{{ !_contractManager.data.program ? 'is-invalid' : '' }}"
                  [items]="_contractService.programs" [closeOnSelect]="true" [clearable]="false" [(ngModel)]="_contractManager.data.program">
                </ng-select>
              </div>
              <div class="form-group col-md-4 col-12">
                <label for="company_offices_list">{{ "MENU.COMPANY_OFFICES" | translate }}<sup class="text-danger">*</sup></label>
                <ng-select id="company_offices_list" bindLabel="name" bindValue="id" class="{{ !_contractManager.data.company_office_id ? 'is-invalid' : '' }}"
                  [items]="company_offices_list" [closeOnSelect]="true" [clearable]="false" [(ngModel)]="_contractManager.data.company_office_id">
                </ng-select>
              </div>
              <div class="form-group col-12" [ngClass]="{'col-md-4': !_contractManager.typeIsApprendistato && !_contractManager.typeIsStage, 'col-md-3': _contractManager.typeIsApprendistato || _contractManager.typeIsStage}">
                <label for="contract_start_date">{{ "START_DATE" | translate }}<sup class="text-danger">*</sup></label>
                <app-datepickr id="contract_start_date" [minDate]="today_date" [displayMonths]="1" [isInvalid]="!_contractManager.data.start_date" (onSelect)="_contractManager.data.start_date = $event; _contractManager.updateData('data')"></app-datepickr>
              </div>
              <div *ngIf="!_contractManager.typeIsIndeterminate" class="form-group col-12"
                [ngClass]="{'col-md-4': _contractManager.typeIsApprendistato || _contractManager.typeIsStage, 'col-md-6': (!_contractManager.typeIsApprendistato && !_contractManager.typeIsStage)}">
                <label for="contract_end_date">{{ "END_DATE" | translate }}<sup class="text-danger" *ngIf="this._contractManager.data.contract !== 1">*</sup></label>
                <app-datepickr id="contract_end_date" [minDate]="_contractManager.data.end_date" [displayMonths]="1" [isInvalid]="!_contractManager.data.end_date" (onSelect)="_contractManager.data.end_date = $event; _contractManager.updateData('data')"></app-datepickr>
              </div>
            </div>
            <!-- /TYPE CONTRACT INFOMRATION-->

            <!-- COST CONTRACT INFOMRATION-->
            <div class="row">
              <div class="form-group col-12">
                <h4 class="mb-0 mt-2">{{ "EMPLOYEE_COSTS" | translate }}</h4>
              </div>
              <div class="form-group col-12" *ngIf="_contractManager.current_lvl && _contractManager.next_lvl && !_contractManager.typeIsStage">
                <p class="mb-0 font-small-4">
                  {{ "MINIMUM_RAL_FOR_LEVEL" | translate }}
                  <strong>{{ _utilService.addDotsToNumber(_contractManager.current_lvl.salary_yearly_gross) }}&euro;</strong>
                  <span *ngIf="_contractManager.data.level != 'B3'">
                    | {{ "MAXIMUM_RAL_FOR_LEVEL" | translate }} <strong>{{ _utilService.addDotsToNumber(_contractManager.next_lvl.salary_yearly_gross) }}&euro;</strong></span>
                </p>
              </div>
              <div class="form-group col-md-6 col-12" *ngIf="!_contractManager.typeIsStage">
                <label for="salary_yearly_gross">{{ "SALARY_YEARLY_GROSS" | translate }}<sup class="text-danger">*</sup></label>
                <div class="input-group input-group-merge {{ !_contractManager.data.salary_yearly_gross ? 'is-invalid' : '' }}">
                  <div class="input-group-prepend">
                    <span class="input-group-text">&euro;</span>
                  </div>
                  <input [readOnly]="!_contractManager.current_lvl || !_contractManager.next_lvl" type="text" id="salary_yearly_gross" [(ngModel)]="_contractManager.data.salary_yearly_gross" class="form-control bg-white {{ !_contractManager.data.salary_yearly_gross ? 'is-invalid' : '' }}" (change)="transformRal($any($event.target).value)" />
                </div>
              </div>
              <div class="form-group col-md-3 col-12" *ngIf="!_contractManager.typeIsStage">
                <label for="bonus">{{ "MONTHLY_BONUSES" | translate }}</label>
                <div class="input-group input-group-merge">
                  <div class="input-group-prepend">
                    <span class="input-group-text">&euro;</span>
                  </div>
                  <input type="text" id="bonus" class="form-control bg-white" [readOnly]="!_contractManager.current_lvl || !_contractManager.next_lvl" (change)="_contractManager.updateDataFromBonus($event.target.value)" [ngModel]="_contractManager.data.bonus | currency: 'EUR': ''" />
                </div>
              </div>
              <div class="form-group col-md-3 col-12" *ngIf="!_contractManager.typeIsStage">
                <label for="production_bonus">{{ "PRODUCTION_BONUS" | translate }}</label>
                <div class="input-group input-group-merge">
                  <div class="input-group-prepend">
                    <span class="input-group-text">&euro;</span>
                  </div>
                  <input type="text" id="production_bonus" class="form-control bg-white" [readOnly]="!_contractManager.current_lvl || !_contractManager.next_lvl" (change)="_contractManager.updateDataFromProductionBonus($event.target.value)" [ngModel]="_contractManager.data.production_bonus | currency: 'EUR': ''" />
                </div>
              </div>
              <div class="col-12"></div>
              <div class="form-group col-md-4 col-12">
                <label for="net_monthly_12">{{ _contractManager.typeIsStage ? ("SALARY_MONTH" | translate) : ("SALARY_MONTH_12" | translate) }}</label>
                <div class="input-group input-group-merge">
                  <div class="input-group-prepend">
                    <span class="input-group-text {{ !_contractManager.typeIsStage ? 'bg-readonly' : '' }}">&euro;</span>
                  </div>
                  <input [readOnly]="!_contractManager.typeIsStage" type="text" id="net_monthly_12" class="form-control" [(ngModel)]="_contractManager.data.net_monthly_12" (change)="_contractManager.updateData()" />
                </div>
              </div>
              <div class="form-group col-md-4 col-12" *ngIf="!_contractManager.typeIsStage">
                <label for="net_monthly_13">{{ "SALARY_MONTH_13" | translate }}</label>
                <div class="input-group input-group-merge">
                  <div class="input-group-prepend">
                    <span class="input-group-text bg-readonly">&euro;</span>
                  </div>
                  <input readonly="readonly" type="text" id="net_monthly_13" class="form-control" [value]="_contractManager.data.net_monthly_13" />
                </div>
              </div>
              <div class="form-group col-md-4 col-12" *ngIf="!_contractManager.typeIsStage">
                <label for="total_monthly_13">{{ "TOTAL_SALARY_MONTH_13" | translate }}</label>
                <div class="input-group input-group-merge">
                  <div class="input-group-prepend">
                    <span class="input-group-text bg-readonly">&euro;</span>
                  </div>
                  <input readonly="readonly" type="text" id="total_monthly_13" class="form-control" [value]="_contractManager.data.total_net_monthly_13" />
                </div>
              </div>
            </div>
            <!-- /COST CONTRACT INFOMRATION-->

            <!-- BONUS TICKET CONTRACT INFOMRATION-->
            <div class="row" *ngIf="!_contractManager.typeIsStage">
              <div class="form-group col-12">
                <h4 class="mb-0 mt-2">{{ "BONUS_TICKET" | translate }}</h4>
              </div>
              <div class="form-group col-md-3 col-12">
                <label for="ticket_type">{{ "TICKET_TYPE" | translate }}</label>
                <select name="ticket_type" id="ticket_type" class="form-control" [(ngModel)]="_contractManager.data.ticket_type"
                  (change)="_contractManager.data.ticket_month_number = _contractManager.data.ticket_type === 'variabile' ? 20 : 0; _contractManager.updateData('ticket')">
                  <option disabled>{{ "TICKET_TYPE" | translate }}</option>
                  <option value="fisso">{{ "STATIC" | translate }}</option>
                  <option value="variabile">{{ "VARIABLE" | translate }}</option>
                </select>
              </div>
              <div class="form-group col-md-3 col-12">
                <label for="ticket_month_number">{{ "TICKET_MONTH_NUMBER" | translate }}</label>
                <input type="number" (change)="_contractManager.updateData('ticket')" [readOnly]="_contractManager.data.ticket_type === 'variabile'" id="ticket_month_number" class="form-control" [(ngModel)]="_contractManager.data.ticket_month_number" />
              </div>
              <div class="form-group col-md-3 col-12">
                <label for="ticket_value">{{ "TICKET_DAILY_VALUE" | translate }}</label>
                <div class="input-group input-group-merge">
                  <div class="input-group-prepend">
                    <span class="input-group-text">&euro;</span>
                  </div>
                  <input type="text" id="ticket_value" class="form-control" [(ngModel)]="_contractManager.data.ticket_value" (change)="transformTicketValue($any($event.target))" />
                </div>
              </div>
              <div class="form-group col-md-3 col-12">
                <label for="total_monthly_13">{{ "TICKET_TOTAL_MONTH" | translate }}</label>
                <div class="input-group input-group-merge">
                  <div class="input-group-prepend">
                    <span class="input-group-text bg-readonly">&euro;</span>
                  </div>
                  <input readonly="readonly" type="text" class="form-control" [value]="calculateTicketTotalMonth()" />
                </div>
              </div>
            </div>
            <!-- /BONUS TICKET CONTRACT INFOMRATION-->

            <!-- FOOTER PROPOSE CONTRACT SECTION-->
            <div class="row border-top pt-2 mt-1 align-items-center">
              <div class="col-md-2 col-12 contract-daily-cost">
                {{ "RATE_REQUEST" | translate }}
                <strong>{{ _utilService.addDotsToNumber(request.rate || 0) }} €</strong>
              </div>
              <div class="col-md-4 col-12 contract-daily-cost">
                {{ "TOTAL_SALARY_DAILY" | translate }}
                <strong>{{ _contractManager.data.total_daily }} &euro;</strong>
              </div>
              <div class="col-md-6 col-12 text-right" has_capability="create_bargaining">
                <button class="btn btn-primary" (click)="submit()" [disabled]="isDisabledSave()">{{ "SAVE" | translate }}</button>
              </div>
            </div>
            <!-- /FOOTER PROPOSE CONTRACT SECTION-->
          </div>
        </div>
        <!-- /PROPOSE_CONTRACT_SECTION-->
      </section>
    </div>
  </div>
</div>